export default "__VITE_ASSET__C97v10xn__"